<template>
  <div>

    <v-row align="center">
      <v-col cols="12" sm="5">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="periodText"
              label="Período"
              prepend-inner-icon="mdi-calendar"
              readonly
              clearable
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
              @click:clear="clear()"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="period"
            type="month"
            locale="pt-BR"
            :max="maxPeriod"
            no-title
            scrollable
            @change="select()"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4" v-if="current">
        <v-alert dense text type="info" class="mb-0">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="3" v-if="current">
        <v-btn @click="csv()">CSV</v-btn>
      </v-col>
    </v-row>

    <div v-if="current">

      <v-simple-table class="mt-6">
        <thead>
          <tr>
            <th>Contato</th>
            <th>Data/Hora</th>
            <th>Parceiro recebido</th>
            <th>Parceiro conhecido</th>
            <th>Nota recebida</th>
            <th>Nota reconhecida</th>
            <th>Mensagem</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in current" :key="item.id">
            <td><v-chip>{{ item.contact }}</v-chip></td>
            <td>{{ item.created | formatDate }} {{ item.created | formatTime}}</td>
            <td>{{ item.partnerReceived }}</td>
            <td>{{ item.partnerKnownName }}</td>
            <td>{{ item.scoreReceived }}</td>
            <td>{{ item.scoreKnown }}</td>
            <td>{{ item.feedback }}</td>
            <td><v-btn icon :to="'/nps/' + item.id" title="Detalhes"><v-icon>mdi-magnify</v-icon></v-btn></td>
          </tr>
        </tbody>
      </v-simple-table>

    </div>

  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: function () {
    var now = new Date();
    var month = now.getMonth() + 1;
    var period = now.getFullYear() + "-" + (month < 10 ? "0" + month : month);
    return {
      current: null,
      menu: false,
      period: period,
      maxPeriod: period,
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    periodText: function () {
      if (!this.period) return "Todos";
      var exp = this.period.split("-");
      return this.months[parseInt(exp[1], 10) - 1] + " / " + exp[0];
    },
  },
  created: function () {
    this.list();
  },
  methods: {
    select: function () {
      this.menu = false;
      this.list();
    },
    clear: function () {
      this.period = null;
      this.menu = false;
      this.list();
    },
    list: function () {
      var me = this;
      var token = localStorage.getItem("token");
      var params = {};
      if (me.period) {
        var exp = me.period.split("-");
        params.year = parseInt(exp[0], 10);
        params.month = parseInt(exp[1], 10);
      }
      me.current = null;
      api
        .get("/nps", {
          params: params,
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function () {
          console.log("list fail");
        });
    },
    escapeCsv: function(value){
      var text = value == null ? "" : String(value);
      text = text.replace(/(\r\n|\n|\r)/gm, "");
      if (text.indexOf(";") >= 0 || text.indexOf("\"") >= 0) {
        text = "\"" + text.replace(/"/g, "\"\"") + "\"";
      }
      return text;
    },
    csv: function(){
      var me = this;
      var content = "";
      for(var i=0;i<this.current.length;i++){
        let nps = this.current[i];
        let created = this.$options.filters.formatDate(nps.created) + " " + this.$options.filters.formatTime(nps.created);
        let fields = [nps.id, nps.contact, created, nps.partnerReceived, nps.partnerKnownName, nps.scoreReceived, nps.scoreKnown, nps.feedback];
        content += fields.map(function (field) { return me.escapeCsv(field); }).join(";") + "\n";
      }
      var blob = new Blob([content], { type: "text/csv" });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      let df = new Date().toISOString();
      a.download = "nps-"+df+".csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }
};
</script>
